"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockButton = void 0;
const slate_react_1 = require("slate-react");
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
// utils
const is_block_active_1 = require("../utils/is-block-active");
const toggle_block_1 = require("../utils/toggle-block");
const button_styles_1 = require("./button-styles");
function BlockButton({ format, icon, }) {
    const classes = (0, button_styles_1.useStyles)();
    const editor = (0, slate_react_1.useSlate)();
    const active = (0, is_block_active_1.isBlockActive)(editor, format);
    return (react_1.default.createElement("button", { onMouseDown: (event) => {
            event.preventDefault();
            (0, toggle_block_1.toggleBlock)(editor, format);
        }, className: (0, clsx_1.default)(classes.button, { [classes.active]: active }) }, icon));
}
exports.BlockButton = BlockButton;
//# sourceMappingURL=block-button.js.map